import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-view-pdf-video",
  templateUrl: "./view-pdf-video.component.html",
  styles: [
    `
      :host {
        position: relative;
        display: block;
      }
      button {
        position: absolute;
        top: 0;
        right: 0;
      }
    `,
  ],
})
export class ViewPdfVideoComponent implements OnInit {
  item: string;
  extension: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ViewPdfVideoComponent>
  ) {}

  ngOnInit() {
    var extn = this.data.fileUrls.name.split(".").pop();
    this.extension = extn;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
   // Method 1: Download using anchor tag (works for same-origin URLs)
  downloadImage() {
    if (this.data.fileUrls?.url) {
      const link = document.createElement('a');
      link.href = this.data.fileUrls.url;
      link.download = this.data.fileName || 'image';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  // Method 2: Download using fetch (works for cross-origin URLs)
  async downloadImageWithFetch() {
    if (this.data.fileUrls?.url) {
      try {
        const response = await fetch(this.data.fileUrls.url);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.data.fileName || 'image';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading image:', error);
        // Fallback: Open in new tab
        window.open(this.data.fileUrls.url, '_blank');
      }
    }
  }

  // Method 3: Download using XMLHttpRequest (with progress tracking)
  downloadImageWithProgress() {
    if (this.data.fileUrls?.url) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.data.fileUrls.url, true);
      xhr.responseType = 'blob';
      
      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = xhr.response;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = this.data.fileName || 'image';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      };
      
      xhr.onerror = () => {
        console.error('Download failed');
        // Fallback: Open in new tab
        window.open(this.data.fileUrls.url, '_blank');
      };
      
      xhr.send();
    }
  }

  openFullScreen() {
    if (this.data.fileUrls?.url) {
      window.open(this.data.fileUrls.url, '_blank');
    }
  }
}
